import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import dashboard from './dashboardPage/handler';
import feedback from './feedbackPage/handler';
import logs from './logsPage/handler';
import events from './eventsPage/handler';

export default pipeHandlers(common, dashboard, feedback, logs, events);
